import { render, staticRenderFns } from "./ImgMan.vue?vue&type=template&id=d5d620ba&scoped=true"
import script from "./ImgMan.vue?vue&type=script&lang=js"
export * from "./ImgMan.vue?vue&type=script&lang=js"
import style0 from "./ImgMan.vue?vue&type=style&index=0&id=d5d620ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d620ba",
  null
  
)

export default component.exports